import { render, staticRenderFns } from "./TunnelPaymentMethod.vue?vue&type=template&id=647cfc93&scoped=true"
import script from "./TunnelPaymentMethod.vue?vue&type=script&lang=js"
export * from "./TunnelPaymentMethod.vue?vue&type=script&lang=js"
import style0 from "./TunnelPaymentMethod.vue?vue&type=style&index=0&id=647cfc93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647cfc93",
  null
  
)

export default component.exports